export const inputSanitization = (e) => {
  // Filter out any characters that aren't letters, numbers, spaces, or hyphens
  const sanitizedValue = e.target.value.replace(/[^a-zA-Z0-9\s-]/g, '');
  return sanitizedValue;
};

export const addressSanitization = (e) => {
  // Filter to allow characters commonly found in addresses:
  // - Letters and numbers
  // - Spaces and hyphens
  // - Periods (for St., Ave., etc.)
  // - Commas (for address parts)
  // - Forward slashes (for unit numbers)
  // - Hash/number sign (for apt/unit numbers)
  const sanitizedValue = e.target.value.replace(/[^a-zA-Z0-9\s,.\-/#]/g, '');
  return sanitizedValue;
};

export const urlSanitization = (e) => {
  // ALLOWED characters:
  // - Letters from any language (Unicode categories "L" for letters)
  // - Numbers (0-9)
  // - Hyphen (-)
  // - Underscore (_)
  // - Period (.)
  //
  // This supports:
  // - Latin letters (a-z, A-Z)
  // - Greek letters (α-ω, Α-Ω)
  // - Arabic letters (ا-ي)
  // - Chinese characters
  // - And letters from all other languages
  //
  // EXCLUDED characters for safety:
  // - Forward slash (/)
  // - Backslash (\)
  // - Question mark (?)
  // - Pound/hash (#)
  // - Percent (%)
  // - Square brackets ([ ])
  // - Curly braces ({ })
  // - At symbol (@)
  // - Exclamation mark (!)
  // - Dollar sign ($)
  // - Ampersand (&)
  // - Single/double quotes (' ")
  // - Parentheses ( )
  // - Asterisk (*)
  // - Plus (+)
  // - Comma (,)
  // - Semicolon (;)
  // - Equals (=)
  // - Angle brackets (< >)
  // - Pipe (|)
  // - Grave accent (`)
  // - Caret (^)
  // - Tilde (~)
  // - Colon (:)
  // - Space ( )
  const sanitizedValue = e.target.value.replace(/[^\p{L}\p{N}\-_.]/gu, '');
  return sanitizedValue;
};
